<template>
    <div class="people-list">
        <ul class="list digits custom-scrollbar">
            <li class="clearfix" v-for="(user, index) in users" :key="index" @click="setActiveuser(user.id)">
                <img class="rounded-circle user-image" :src="getImgUrl(user.thumb)" alt="" />
                <div class="about">
                    <div class="name">{{ user.name }}</div>
                    <div class="status">
                        <i class="fa fa-share font-success mr-1"></i>{{ user.lastSeenDate }}
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    data() {
        return {
            currentchat: [],
            chatmenutoogle: false,
            activeTab: 'call',
        }
    },
    computed: {
        ...mapState({
            activeuser: (state) => state.chat.activeuser,
            users: (state) =>
                state.chat.users.filter(function (user) {
                    if (user.id !== 0) return user;
                }),
            serchUser: (state) => state.chat.serchUser,
            activeusers: (state) =>
                state.chat.users.filter(function (user) {
                    if (user.active === 'active' && user.id !== 0) return user;
                }),
            currentChat() {
                return (this.currentchat = this.$store.getters['chat/currentChat']);
            },
        }),
    },
    methods: {
        getImgUrl(path) {
            return require('../../../assets/images/' + path);
        },
        tabContent(val) {
            this.activeTab = val;
        },
        setActiveuser: function (id) {
            this.$store.dispatch('chat/setActiveuser', id);
        },
    }
}
</script>